import { FocusSelectionParams } from '../../../../../coaching-base/config';
import { TranscriptFocus } from '../../../../../coaching-base/general';
import { BehaviourItem } from '../../../../../coaching-tags/models/behaviour.coaching.model';
import { createAction } from '../../../../../store.model';
import { ActionType } from '../behaviour-selection-dialog.action';

export interface Load {
    performerId?: number;
    focusSelectionParams?: FocusSelectionParams;
    focuses?: TranscriptFocus[];
}
export const load = createAction<ActionType, {}>(
    ActionType.COACHING_DETAIL__BSD__LOAD,
);

export interface LoadResult {
    behaviours?: BehaviourItem[];
    focuses?: TranscriptFocus[];
}

export const loadResult = createAction<ActionType, LoadResult>(
    ActionType.COACHING_DETAIL__BSD__LOAD_RESULT,
);
